/**
 * Types for SystemRule maintenance
 */

export interface SystemRuleMaintenanceDto {
  id: number;
  companyNo: string;
  ruleID: number;
  ruleType: number;  // 0=System, 1=User
  ruleFunctionType: number;
  lng1: string;  // Norwegian description
  lng2: string | null;  // English description
  sqlExpression: string | null;
  activeYesNo: boolean;
  createdBy: string | null;
  created: string | null;
  updatedBy: string | null;
  lastUpdate: string | null;
  ruleTypeName: string;
  isUserRule: boolean;
  isEditable: boolean;
}

export interface CreateSystemRuleRequest {
  lng1: string;
  lng2?: string;
  sqlExpression: string;
  ruleFunctionType: number;
  activeYesNo: boolean;
}

export interface UpdateSystemRuleRequest {
  lng1: string;
  lng2?: string;
  sqlExpression: string;
  ruleFunctionType: number;
  activeYesNo: boolean;
}

export interface ValidateSqlRequest {
  sqlExpression: string;
}

export interface SqlValidationResult {
  isValid: boolean;
  errorMessage: string | null;
  errorLine: number | null;
  errorColumn: number | null;
}

export interface SqlPreviewRequest {
  sqlExpression: string;
  maxRows: number;
}

export interface SqlPreviewResult {
  success: boolean;
  errorMessage: string | null;
  affectedRowCount: number;
  previewRows: Record<string, unknown>[];
  columnNames: string[];
  convertedSelectQuery: string | null;
}

export interface RuleFunctionTypeDto {
  id: number;
  name: string;
  description: string | null;
}

// UI State types
export interface SystemRuleFormData {
  lng1: string;
  lng2: string;
  sqlExpression: string;
  ruleFunctionType: number;
  activeYesNo: boolean;
}

export const emptyFormData: SystemRuleFormData = {
  lng1: '',
  lng2: '',
  sqlExpression: '',
  ruleFunctionType: 0,
  activeYesNo: true,
};
